import {tv} from 'tailwind-variants'
import {type OmitStrict} from 'type-zoo'
import {type HgTableTextCell} from '~/design-system/hg/components/HgTableCell/types'
import StandardTable from '~/design-system/hg/modules/HgTable/_components/StandardTable'

type WYSIWYGTableCell = OmitStrict<HgTableTextCell, 'iconType' | 'image'>

export type WYSIWYGTableRow = [
  WYSIWYGTableCell,
  WYSIWYGTableCell,
  WYSIWYGTableCell?,
  WYSIWYGTableCell?,
]

export type WYSIWYGTableProps = {
  columnTitles?: WYSIWYGTableRow | null
  rows: WYSIWYGTableRow[]
  asymmetrical?: boolean
  className?: string
}

const tableVariant = tv({
  base: 'col-span-full mt-s5',
  variants: {
    numberOfColumns: {
      2: 'md:col-span-8 md:col-start-3 lg:col-start-5',
      3: 'lg:col-span-12 lg:col-start-3',
      4: 'lg:col-span-12 lg:col-start-3',
    },
  },
})

export const HgArticleWYSIWYGTable = ({
  columnTitles,
  rows,
  asymmetrical,
  className,
}: WYSIWYGTableProps) => {
  return (
    <div
      className={tableVariant({numberOfColumns: rows[0]?.length, class: className})}
    >
      <StandardTable
        columnTitles={columnTitles}
        rows={rows}
        asymmetrical={asymmetrical}
      />
    </div>
  )
}
